export default () => {
  const FADE_TOGGLE = 150;
  const $window = $(window);
  const $materialDetailWrapper = $('#js-material-detail-wrapper');

  if($materialDetailWrapper.length > 0) {
    function materialZoom() {
      const $materialDetail = $('#js-material-detail');
      const $materialDetailBg = $('#js-material-detail-bg');

      $materialDetailBg.on('click', function(e) {
        if(window.innerWidth > tabletBreakpoint) {
          let inOverlay = $(e.target).closest('.c-material-detail__overlay-wrapper');
          if(!inOverlay.length > 0) {
            $materialDetail.toggleClass('is-full-screen');
          }
        }
      });
    }

    materialZoom();
  }
};
